import React from 'react'

const DoxLargeCheckMark = () => (
    <svg width="128" height="106" viewBox="0 0 256 212" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M105.44 15.2932L112.907 22.7599L44.96 90.7066L15.0933 60.8399L22.56 53.3732L44.96 75.7732L105.44 15.2932ZM105.44 0.19989L44.96 60.6799L22.56 38.2799L0 60.8399L44.96 105.8L128 22.7599L105.44 0.19989Z" fill="#89D49F" />
    </svg>
)

export default DoxLargeCheckMark